import React, { ReactNode, useState } from "react";
import Hamburger from "hamburger-react";
import AnchorLink from "react-anchor-link-smooth-scroll";

export interface NavBarItemProps {
  name: string;
  linkTo: string;
}

export const NavBarItem: React.FC<NavBarItemProps> = (props) => {
  return (
    <AnchorLink
      offset={70}
      href={props.linkTo}
      className=" text-primary pl-5 pr-5 pt-2 pb-2 m-2 md:text-xl flex flex-col justify-center hover:bg-on_background hover:rounded-2xl hover:text-background"
    >
      <div>{props.name}</div>
    </AnchorLink>
  );
};

export interface NavBarProps {
  children: ReactNode[];
}

const NavBar: React.FC<NavBarProps> = (props) => {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const itemsStyle = `${menuExpanded ? "flex" : "hidden md:flex"}`;

  const children = props.children.map((c) => (
    <div onClick={() => setMenuExpanded(false)}>{c}</div>
  ));

  return (
    <nav className="px-5 backdrop-blur-lg bg-background/50 flex flex-col md:flex-row items-center justify-between min-w-max">
      <div className="text-white flex flex-row flex-nowrap justify-between  min-w-full md:min-w-0 items-center">
        <AnchorLink offset={120} href="#welcome" className="p-1 m-2">
          <h1
            className="font-normal text-4xl text-white scale-75 md:scale-100"
            onClick={() => setMenuExpanded(false)}
          >
            <img src="images/logo_transparent.png" alt="logo" width="50px" />
          </h1>
        </AnchorLink>
        <div className="md:hidden pb-2 scale-75">
          <Hamburger
            toggled={menuExpanded}
            onToggle={(open) => setMenuExpanded(open)}
          />
        </div>
      </div>

      <div
        className={`flex-col md:flex-row flex-nowrap justify-around items-center ${itemsStyle}`}
      >
        {children}
      </div>
    </nav>
  );
};

export default NavBar;
